import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HeaderSearch from '../../../../components/headers/catalogs/HeaderSearch';
import HomeLayout from '../../../../layouts/HomeLayout';
import MainLoader from '../../../../components/Loaders/MainLoader';
import Error from '../../../../components/errors/Error';
import DropdownForm from '../../../../components/Inputs/formInput/DropdonwForm';
import BtnContent from '../../../../components/buttons/BtnContent';
//SLICE
import { getStudentsWithOutSpacesThunk, initialStateReports } from '../../../../store/slices/reportes/reports.slice';
import { useForm } from 'react-hook-form';
import { getCoursesThunk } from '../../../../store/slices/catalogs/courses.slice';
import { FaPenAlt, FaRegFileExcel, FaSearch } from 'react-icons/fa';
import { generateExcelCuposNoReservados } from '../../../../resources/generateExcels';

const StudentWithoutSpaceList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, error } = useSelector(state => state.reports);
    const couses = useSelector(state => state.courses.items);
    const [searchTerm, setSearchTerm] = useState('');
    const [excelData, setExcelData] = useState({});
    const isLoading = useSelector(state => state.isLoadingSlice);
    const { handleSubmit, register, formState: { errors } } = useForm();

    useEffect(() => {
        dispatch(getStudentsWithOutSpacesThunk());
        dispatch(getCoursesThunk());
        return () => {
            dispatch(initialStateReports());
        };
    }, []);

    const filteredProducts = useMemo(() => {
        if (searchTerm) {
            return items.rows?.filter(item =>
                item.student?.apellido.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        return items.rows;
    }, [searchTerm, items]);

    const onSubmit = (data) => {
        setExcelData(data)
        dispatch(getStudentsWithOutSpacesThunk(data));
    }

    const handleGenerateExcel = () => {
        generateExcelCuposNoReservados(excelData)
    }

    return (
        <HomeLayout>
            {isLoading || items?.length === 0 ? (
                <MainLoader />
            ) : (
                <div className='m-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 items-center '>
                        <div className='pt-7 w-full'>
                            <HeaderSearch
                                title={t("Estudiantes")}
                                searchTerm={searchTerm}
                                funtion={e => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)} className='flex w-full items-center p-2 gap-5'>
                            <DropdownForm
                                label={t("Curso")}
                                input="input"
                                spam={true}
                                register={register("curso")}
                                options={couses}
                            />
                            <div className='pt-7'>
                                <BtnContent type="submit">
                                    <FaSearch />
                                    Buscar...
                                </BtnContent>
                            </div>
                        </form>
                        <div className='w-full flex justify-end pt-7'>
                            <button
                                type='button'
                                onClick={handleGenerateExcel}
                                className="flex items-center gap-2 bg-gradient-to-r from-green-400 to-green-500 text-white px-4 py-1 rounded-md shadow-md hover:from-green-500 hover:to-green-600 transition-all duration-300 ease-in-out"
                            >
                                <FaRegFileExcel />
                                Exportar a excel
                            </button>
                        </div>
                    </div>

                    <div className="h-[89%] flex flex-col  rounded overflow-hidden">
                        <div className="overflow-y-auto flex-1 contenedor">
                            <table className="min-w-full table-zebra table-fixed border-collapse text-[13px] text-left">
                                <thead className="sticky top-0 bg-white">
                                    <tr className='text-left h-[50px] bg-p-orange/80 text-white'>
                                        <th className='px-2'>{t("Información Estudiante")}</th>
                                        <th>{t("Información Respesentante")}</th>
                                        <th>{t("Observaciones")}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredProducts?.map((user, index) =>
                                        <tr className='h-[50px] p-2' key={index}>
                                            <td className='w-[400px] px-2'>
                                                <div className='flex flex-col gap-0'>
                                                    <p className='flex items-center gap-2 text-p-sky text-[18px] font-semibold'>
                                                        {user.student?.apellido} {user.student?.nombre}
                                                    </p>
                                                    <p className='flex items-center gap-2 text-gray-500'>
                                                        {user.student?.ci_estudiante}
                                                    </p>
                                                    <p className='flex items-center gap-2 text-gray-500'>
                                                        {user.student?.course?.name + ', ' + user.student?.level?.name}
                                                    </p>
                                                </div>
                                            </td>
                                            <td className='w-[450px]'>
                                                <div className='flex flex-col gap-0'>
                                                    <p className='flex items-center gap-2 text-p-sky text-[18px] font-semibold'>
                                                        {user.parent?.apellido} {user.parent?.nombre}
                                                    </p>
                                                    <p className='flex items-center gap-2 text-gray-500'>
                                                        {'CI: ' + user.parent?.ci_padre} / {'Telf: ' + user.parent?.celular}
                                                    </p>
                                                    <p className='flex items-center gap-2 text-gray-500'>
                                                        {user.parent?.email}
                                                    </p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='flex flex-col gap-2'>
                                                    <p className='flex items-center gap-2 text-p-sky text-[18px]'>
                                                        <span className='bg-p-sky text-white px-2 rounded-md text-[13px] font-semibold' >{'Proceso Pendiente'} </span>
                                                    </p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='w-full flex justify-center items-center'>
                                                    <button
                                                        type='button'
                                                        onClick={handleGenerateExcel}
                                                        className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white font-semibold px-4 py-1 rounded-md shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out"
                                                    >
                                                        <FaPenAlt />
                                                        Seguimiento
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot className="sticky bottom-0 z-10 bg-gray-100 text-gray-700">
                                    <tr>
                                        <td colSpan={6} className="text-right p-2">
                                            Total de registros:{" "}
                                            <span className="text-p-sky text-[18px]">{items.count}</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default StudentWithoutSpaceList;
